import { useContext } from 'react';

import { IntervalContext } from '../components/IntervalContext';

const useIntervalContext = () => {
  const context = useContext(IntervalContext);
  if (!context) {
    throw new Error(
      'Did you forget to wrap component in IntervalContextProvider?',
    );
  }

  return context;
};

export default useIntervalContext;
